import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: 'pt-BR', // Force initial language to PT-BR (ignores detection)
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      'en-US': {
        translation: {
          common: {
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            close: 'Close',
            back: 'Back',
            loading: 'Loading...',
            search: 'Search',
            actions: 'Actions',
            status: 'Status',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            yes: 'Yes',
            no: 'No',
            description: 'Description',
            active: 'Active',
            inactive: 'Inactive',
            upload: 'Upload',
            reset: 'Reset Changes',
            reset_order: 'Reset Order',
            saving: 'Saving...',
            api_error: 'API Error',
            unknown_error: 'Unknown error',
            next: 'Next',
            previous: 'Previous',
            page: 'Page',
            view: 'View',
            created_at: 'Created At',
            updated_at: 'Updated At',
            total: 'Total',
            quantity: 'Quantity',
            confirm: 'Confirm',
          },
          layout: {
            dashboard: 'Dashboard',
            module_flow: 'Module Flow',
            message_flow: 'Message Flow',
            clients: 'Clients',
            products: 'Products',
            catalog: 'Catalog',
            cart: 'Cart',
            calendar: 'Calendar',
            settings: 'Settings',
            profile: 'Profile',
            logout: 'Logout',
            purchases: 'Purchases',
            contracts: 'Contracts',
            templates: 'Templates',
            client_contracts: 'Client Contracts',
          },
          calendar: {
            title: 'Calendar',
            new_appointment: 'New Appointment',
            check_availability: 'Check Availability',
            save_appointment: 'Save Appointment',
            cancel: 'Cancel',
            description: 'Description (Optional)',
            search_client: 'Search Client (Name, Phone, CPF/CNPJ)',
            timezone: 'Timezone',
            date: 'Date',
            time: 'Time',
            delete: 'Delete',
            close: 'Close',
            details: 'Appointment Details',
            status: 'Status',
            loading_clients: 'Loading clients...',
            no_clients: 'No clients found or type to search',
            selected: 'Selected',
            success_create: 'Appointment created successfully!',
            success_delete: 'Appointment deleted successfully!',
            error_create: 'Failed to create appointment',
            error_delete: 'Failed to delete appointment',
            error_check: 'Availability check failed',
            msg_check_required: 'Please select a start time and ensure calendar settings are loaded.',
            msg_save_required: 'Client, start time, and calendar settings are required.',
            msg_slot_unavailable: 'Selected slot is not available or availability not checked.',
          },
          landing: {
            title: 'Automate Your Business with Smart WhatsApp Flows',
            subtitle: 'Streamline client interactions, scheduling, contracts, and payments - all through WhatsApp.',
            get_started: 'Get Started Now',
            login: 'Login',
            features_title: 'Features',
            whatsapp_title: 'WhatsApp Integration',
            whatsapp_desc: 'Manage all your WhatsApp Business conversations in one place.',
            schedule_title: 'Automatic Scheduling',
            schedule_desc: 'Sync automatically with Google Calendar to manage appointments.',
            payments_title: 'Integrated Payments',
            payments_desc: 'Receive payments directly through WhatsApp with MercadoPago.',
            multitenant_title: 'Multi-tenant',
            multitenant_desc: 'Manage multiple businesses in a single platform.',
            auth: {
              login_title: 'Login to Your Account',
              register_title: 'Create New Account',
              continue_google: 'Continue with Google',
              continue_icloud: 'Continue with iCloud',
              or: 'OR',
              full_name: 'Full Name',
              phone: 'Phone',
              address: 'Address',
              email: 'Email',
              password: 'Password',
              terms: 'By signing up, you agree to our Terms of Service and Privacy Policy',
              submit_login: 'Login',
              submit_register: 'Create Account',
              no_account: "Don't have an account?",
              have_account: 'Already have an account?',
              signup_link: 'Sign Up',
              login_link: 'Login',
              forgot_password: 'Forgot Password?',
              verify_code: 'Verify Reset Code',
            }
          },
          settings: {
            tabs: {
              whatsapp: 'WhatsApp Business',
              mercadopago: 'Mercado Pago',
              calendar: 'Calendar',
              branding: 'Branding',
            },
            whatsapp: {
              title: 'WhatsApp Business API Configuration',
              phone_id: 'Phone Number ID',
              phone_number: 'Phone Number',
              verify_token: 'Verify Token',
              access_token: 'Access Token',
              edit: 'Edit Settings',
              cancel: 'Cancel',
              save: 'Save Changes',
              saving: 'Saving...',
              success: 'Settings updated successfully!',
            },
            mercadopago: {
              title: 'Mercado Pago Configuration',
              public_key: 'Public Key',
              access_token: 'Access Token',
              webhook_secret: 'Webhook Secret',
              user_id: 'MP User ID',
              pix_discount: 'Pix Discount (%)',
              max_installments: 'Max Installments',
              save: 'Save',
              saving: 'Saving...',
            },
            calendar_config: {
              title: 'Calendar Configuration',
              name: 'Calendar Name',
              timezone: 'Timezone',
              max_concurrent: 'Max Concurrent Events',
              duration: 'Appointment Duration (minutes)',
              working_periods: 'Working Periods',
              day: 'Day',
              start_time: 'Start Time (HH:MM)',
              end_time: 'End Time (HH:MM)',
              add_period: 'Add Working Period',
              save: 'Save Calendar Settings',
            },
            branding: {
              title: 'Company Logo',
              current: 'Current Logo',
              preview: 'New Logo Preview',
              select: 'Select Logo',
              upload: 'Upload',
              no_logo: 'No Logo',
              select_file: 'Select a file',
            }
          },
          clients: {
            new_client: 'New Client',
            search_placeholder: 'Search Clients (Name, Phone, CPF/CNPJ)',
            no_clients: 'No clients found.',
            no_match: 'No clients match your search.',
            surname: 'Surname',
            city: 'City',
            state: 'State',
            zip_code: 'Zip Code',
            country: 'Country',
            dob: 'Date of Birth',
            create_success: 'Client created successfully!',
            create_error: 'Failed to save client. Please check the details and try again.',
            update_success: 'Client updated successfully!',
            delete_success: 'Client deleted successfully!',
            required_fields: 'First Name, Surname, and CPF/CNPJ (Client Identification) are required.',
          },
          module_flow: {
            title: 'Module Flow Order',
            save_changes: 'Save Changes',
            updating: 'Updating module order...',
            instructions: "Reorder modules or toggle their inclusion using the eye icon. Click 'Save Changes' to update the flow.",
            no_modules: 'No modules found or configured for this tenant.',
            mark_inactive: 'Mark as Inactive (will be excluded on save)',
            mark_active: 'Mark as Active (will be included on save)',
            move_up: 'Move Up',
            move_down: 'Move Down',
            success: 'Module order updated successfully',
            error: 'Failed to update module order',
          },
          message_flow: {
            title: 'Message Flow Steps',
            select_module: 'Select Module',
            loading_modules: 'Loading modules...',
            no_modules_found: 'No modules found',
            add_step: 'Add Message Step',
            failed_load: 'Failed to load data',
            failed_update: 'Failed to update steps',
            saving_changes: 'Saving changes...',
            no_flow: 'No message flow found or configured for the selected module.',
            editing_flow: 'Editing steps for flow',
            no_steps: "No steps defined for this flow yet. Click 'Add Message Step' to begin.",
            edit_step: 'Edit Message Step',
            new_step: 'Add New Message Step',
            message_content: 'Message Content',
            content_helper: 'Enter the exact text message to be sent.',
            save_step: 'Save Step',
            delete_step: 'Delete Step',
            move_up: 'Move Up',
            move_down: 'Move Down',
            success: 'Message flow steps updated successfully',
          },
          templates: {
            title: 'Contract Template Editor',
            name_label: 'Template Name',
            content_label: 'Template HTML Content',
            content_helper: 'Edit the HTML content for your contract template.',
            preview_title: 'Live Preview',
            no_template: 'No template found. Saving will create a new one.',
            default_name: 'Contract Template',
            default_content: '<p>Enter your contract HTML here.</p>',
            success_save: 'Template saved successfully!',
            error_save: 'Error saving template',
            error_load: 'Error loading template',
            empty_save: 'Cannot save empty template.',
            create_button: 'Create Template',
            update_button: 'Update Template',
          },
          client_contracts: {
            title: 'Client Contracts Status',
            search_placeholder: 'Search Contracts (Client Name, Phone, etc.)',
            client_name: 'Client Name',
            client_phone: 'Client Phone',
            status: 'Status',
            generated_at: 'Generated At',
            signed_at: 'Signed At',
            view_pdf: 'View PDF',
            no_match: 'No contracts match your search.',
            no_contracts: 'No contracts found.',
            statuses: {
              signed: 'Signed',
              awaiting: 'Awaiting Signature',
              generated: 'Generated',
              error: 'Error'
            }
          },
          products: {
            title: 'Product Catalog',
            category: 'Category',
            all_categories: 'All Categories',
            add_category: 'Add Category',
            manage_categories: 'Manage Categories',
            add_product: 'Add Product',
            no_products: 'No products found matching your criteria.',
            no_image: 'No Image',
            price: 'Price',
            sku: 'SKU',
            success_category: 'Category created successfully!',
            success_product: 'Product created successfully!',
            success_update: 'Product updated successfully!',
            success_delete: 'Product deleted successfully!',
            success_delete_cat: 'Category deleted successfully!',
            error_fetch: 'Error fetching products',
            error_category: 'Error creating category',
            error_product: 'Error creating product',
            error_update: 'Error updating product',
            error_delete: 'Error deleting product',
            error_delete_cat: 'Error deleting category',
          },
          cart: {
            title: 'Client Cart Management',
            select_client: 'Select Client',
            search_client: 'Search and Select Client',
            add_item_title: 'Add Item to Cart',
            select_product: 'Select Product',
            cart_for: 'Cart for',
            clear_cart: 'Clear Cart',
            clearing: 'Clearing...',
            empty: 'Cart is empty.',
            item_added: 'Item added to cart.',
            item_removed: 'Cart item removed.',
            cart_cleared: 'Cart cleared successfully.',
            error_add: 'Failed to add item to cart.',
            error_remove: 'Failed to remove item.',
            error_clear: 'Failed to clear cart.',
            required: 'Please select a client, product, and valid quantity.',
          },
            profile: {
            title: 'Profile',
            person_name: 'Person Name',
            tenant_name: 'Tenant / Company Name',
            login_email: 'Login Email',
            edit_profile: 'Edit Profile',
            change_password: 'Change Password',
            delete_account: 'Delete Account',
            deleting: 'Deleting...',
            confirm_delete_title: 'Confirm Account Deletion',
            confirm_delete_body: 'Are you absolutely sure you want to delete your account? All associated data will be permanently lost. This action cannot be undone.',
            confirm_delete: 'Confirm Delete',
            success_update: 'Profile updated successfully!',
            error_update: 'Failed to update profile.',
            all_required: 'All fields are required.',
            custom_question: 'Custom Client Question',
            custom_question_helper: 'Question asked to clients during registration (e.g. "Favorite Color"). Leave empty to disable.',
          },
          purchases: {
            title: 'Purchases (Payment Sessions)',
            session_id: 'Session ID',
            total_amount: 'Total Amount',
            payment_method: 'Payment Method',
            confirmed_at: 'Confirmed At',
            details: 'Details',
            no_sessions: 'No payment sessions found for this client.',
            payment_link: 'Payment Link',
            current_step: 'Current Step',
            external_id: 'External Payment ID',
            preference_id: 'Preference ID',
          }
        }
      },
      'pt-BR': {
        translation: {
          common: {
            save: 'Salvar',
            cancel: 'Cancelar',
            delete: 'Excluir',
            edit: 'Editar',
            close: 'Fechar',
            back: 'Voltar',
            loading: 'Carregando...',
            search: 'Buscar',
            actions: 'Ações',
            status: 'Status',
            name: 'Nome',
            email: 'E-mail',
            phone: 'Telefone',
            address: 'Endereço',
            yes: 'Sim',
            no: 'Não',
            description: 'Descrição',
            active: 'Ativo',
            inactive: 'Inativo',
            upload: 'Enviar',
            reset: 'Desfazer Alterações',
            reset_order: 'Redefinir Ordem',
            saving: 'Salvando...',
            api_error: 'Erro na API',
            unknown_error: 'Erro desconhecido',
            next: 'Próximo',
            previous: 'Anterior',
            page: 'Página',
            view: 'Visualizar',
            created_at: 'Criado em',
            updated_at: 'Atualizado em',
            total: 'Total',
            quantity: 'Quantidade',
            confirm: 'Confirmar',
          },
          layout: {
            dashboard: 'Painel',
            module_flow: 'Fluxo de Módulos',
            message_flow: 'Fluxo de Mensagens',
            clients: 'Clientes',
            products: 'Produtos',
            catalog: 'Catálogo',
            cart: 'Carrinho',
            calendar: 'Agenda',
            settings: 'Configurações',
            profile: 'Perfil',
            logout: 'Sair',
            purchases: 'Compras',
            contracts: 'Contratos',
            templates: 'Modelos',
            client_contracts: 'Contratos de Clientes',
          },
          calendar: {
            title: 'Agenda',
            new_appointment: 'Novo Agendamento',
            check_availability: 'Verificar Disponibilidade',
            save_appointment: 'Salvar Agendamento',
            cancel: 'Cancelar',
            description: 'Descrição (Opcional)',
            search_client: 'Buscar Cliente (Nome, Tel, CPF/CNPJ)',
            timezone: 'Fuso Horário',
            date: 'Data',
            time: 'Hora',
            delete: 'Excluir',
            close: 'Fechar',
            details: 'Detalhes do Agendamento',
            status: 'Status',
            loading_clients: 'Carregando clientes...',
            no_clients: 'Nenhum cliente encontrado ou digite para buscar',
            selected: 'Selecionado',
            success_create: 'Agendamento criado com sucesso!',
            success_delete: 'Agendamento excluído com sucesso!',
            error_create: 'Falha ao criar agendamento',
            error_delete: 'Falha ao excluir agendamento',
            error_check: 'Falha ao verificar disponibilidade',
            msg_check_required: 'Por favor, selecione um horário de início e verifique as configurações da agenda.',
            msg_save_required: 'Cliente, horário de início e configurações da agenda são obrigatórios.',
            msg_slot_unavailable: 'Horário selecionado indisponível ou disponibilidade não verificada.',
          },
          landing: {
            title: 'Automatize seu Negócio com Fluxos Inteligentes de WhatsApp',
            subtitle: 'Otimize interações com clientes, agendamentos, contratos e pagamentos - tudo pelo WhatsApp.',
            get_started: 'Começar Agora',
            login: 'Entrar',
            features_title: 'Funcionalidades',
            whatsapp_title: 'Integração WhatsApp',
            whatsapp_desc: 'Gerencie todas as suas conversas do WhatsApp Business em um só lugar.',
            schedule_title: 'Agendamento Automático',
            schedule_desc: 'Sincronize automaticamente com o Google Calendar para gerenciar compromissos.',
            payments_title: 'Pagamentos Integrados',
            payments_desc: 'Receba pagamentos diretamente pelo WhatsApp com MercadoPago.',
            multitenant_title: 'Multi-inquilino',
            multitenant_desc: 'Gerencie múltiplos negócios em uma única plataforma.',
            auth: {
              login_title: 'Entre na sua Conta',
              register_title: 'Criar Nova Conta',
              continue_google: 'Continuar com Google',
              continue_icloud: 'Continuar com iCloud',
              or: 'OU',
              full_name: 'Nome Completo',
              phone: 'Telefone',
              address: 'Endereço',
              email: 'E-mail',
              password: 'Senha',
              terms: 'Ao se cadastrar, você concorda com nossos Termos de Serviço e Política de Privacidade',
              submit_login: 'Entrar',
              submit_register: 'Criar Conta',
              no_account: "Não tem uma conta?",
              have_account: 'Já tem uma conta?',
              signup_link: 'Cadastre-se',
              login_link: 'Entrar',
              forgot_password: 'Esqueceu a senha?',
              verify_code: 'Verificar Código',
            }
          },
          settings: {
            tabs: {
              whatsapp: 'WhatsApp Business',
              mercadopago: 'Mercado Pago',
              calendar: 'Agenda',
              branding: 'Marca',
            },
            whatsapp: {
              title: 'Configuração da API do WhatsApp Business',
              phone_id: 'ID do Número de Telefone',
              phone_number: 'Número de Telefone',
              verify_token: 'Token de Verificação',
              access_token: 'Token de Acesso',
              edit: 'Editar Configurações',
              cancel: 'Cancelar',
              save: 'Salvar Alterações',
              saving: 'Salvando...',
              success: 'Configurações atualizadas com sucesso!',
            },
            mercadopago: {
              title: 'Configuração do Mercado Pago',
              public_key: 'Chave Pública',
              access_token: 'Token de Acesso',
              webhook_secret: 'Segredo do Webhook',
              user_id: 'ID do Usuário MP',
              pix_discount: 'Desconto Pix (%)',
              max_installments: 'Máximo de Parcelas',
              save: 'Salvar',
              saving: 'Salvando...',
            },
            calendar_config: {
              title: 'Configuração da Agenda',
              name: 'Nome da Agenda',
              timezone: 'Fuso Horário',
              max_concurrent: 'Máx. Eventos Simultâneos',
              duration: 'Duração do Agendamento (minutos)',
              working_periods: 'Períodos de Trabalho',
              day: 'Dia',
              start_time: 'Hora Início (HH:MM)',
              end_time: 'Hora Fim (HH:MM)',
              add_period: 'Adicionar Período',
              save: 'Salvar Configurações',
            },
            branding: {
              title: 'Logo da Empresa',
              current: 'Logo Atual',
              preview: 'Pré-visualização',
              select: 'Selecionar Logo',
              upload: 'Enviar',
              no_logo: 'Sem Logo',
              select_file: 'Selecione um arquivo',
            }
          },
          clients: {
            new_client: 'Novo Cliente',
            search_placeholder: 'Buscar Clientes (Nome, Telefone, CPF/CNPJ)',
            no_clients: 'Nenhum cliente encontrado.',
            no_match: 'Nenhum cliente corresponde à sua busca.',
            surname: 'Sobrenome',
            city: 'Cidade',
            state: 'Estado',
            zip_code: 'CEP',
            country: 'País',
            dob: 'Data de Nascimento',
            create_success: 'Cliente criado com sucesso!',
            create_error: 'Falha ao salvar cliente. Verifique os detalhes e tente novamente.',
            update_success: 'Cliente atualizado com sucesso!',
            delete_success: 'Cliente excluído com sucesso!',
            required_fields: 'Nome, Sobrenome e CPF/CNPJ são obrigatórios.',
          },
          module_flow: {
            title: 'Ordem do Fluxo de Módulos',
            save_changes: 'Salvar Alterações',
            updating: 'Atualizando ordem dos módulos...',
            instructions: "Reordene os módulos ou alterne sua inclusão usando o ícone de olho. Clique em 'Salvar Alterações' para atualizar o fluxo.",
            no_modules: 'Nenhum módulo encontrado ou configurado para este inquilino.',
            mark_inactive: 'Marcar como Inativo (será excluído ao salvar)',
            mark_active: 'Marcar como Ativo (será incluído ao salvar)',
            move_up: 'Mover para Cima',
            move_down: 'Mover para Baixo',
            success: 'Ordem dos módulos atualizada com sucesso',
            error: 'Falha ao atualizar ordem dos módulos',
          },
          message_flow: {
            title: 'Etapas do Fluxo de Mensagens',
            select_module: 'Selecionar Módulo',
            loading_modules: 'Carregando módulos...',
            no_modules_found: 'Nenhum módulo encontrado',
            add_step: 'Adicionar Etapa de Mensagem',
            failed_load: 'Falha ao carregar dados',
            failed_update: 'Falha ao atualizar etapas',
            saving_changes: 'Salvando alterações...',
            no_flow: 'Nenhum fluxo de mensagem encontrado ou configurado para o módulo selecionado.',
            editing_flow: 'Editando etapas para o fluxo',
            no_steps: "Nenhuma etapa definida para este fluxo ainda. Clique em 'Adicionar Etapa de Mensagem' para começar.",
            edit_step: 'Editar Etapa de Mensagem',
            new_step: 'Adicionar Nova Etapa de Mensagem',
            message_content: 'Conteúdo da Mensagem',
            content_helper: 'Digite a mensagem de texto exata a ser enviada.',
            save_step: 'Salvar Etapa',
            delete_step: 'Excluir Etapa',
            move_up: 'Mover para Cima',
            move_down: 'Mover para Baixo',
            success: 'Etapas do fluxo de mensagens atualizadas com sucesso',
          },
          templates: {
            title: 'Editor de Modelos de Contrato',
            name_label: 'Nome do Modelo',
            content_label: 'Conteúdo HTML do Modelo',
            content_helper: 'Edite o conteúdo HTML do seu modelo de contrato.',
            preview_title: 'Pré-visualização',
            no_template: 'Nenhum modelo encontrado. Salvar criará um novo.',
            default_name: 'Modelo de Contrato',
            default_content: '<p>Digite o HTML do seu contrato aqui.</p>',
            success_save: 'Modelo salvo com sucesso!',
            error_save: 'Erro ao salvar modelo',
            error_load: 'Erro ao carregar modelo',
            empty_save: 'Não é possível salvar um modelo vazio.',
            create_button: 'Criar Modelo',
            update_button: 'Atualizar Modelo',
          },
          client_contracts: {
            title: 'Status dos Contratos de Clientes',
            search_placeholder: 'Buscar Contratos (Nome, Telefone, etc.)',
            client_name: 'Nome do Cliente',
            client_phone: 'Telefone do Cliente',
            status: 'Status',
            generated_at: 'Gerado em',
            signed_at: 'Assinado em',
            view_pdf: 'Ver PDF',
            no_match: 'Nenhum contrato corresponde à sua busca.',
            no_contracts: 'Nenhum contrato encontrado.',
            statuses: {
              signed: 'Assinado',
              awaiting: 'Aguardando Assinatura',
              generated: 'Gerado',
              error: 'Erro'
            }
          },
          products: {
            title: 'Catálogo de Produtos',
            category: 'Categoria',
            all_categories: 'Todas as Categorias',
            add_category: 'Adicionar Categoria',
            manage_categories: 'Gerenciar Categorias',
            add_product: 'Adicionar Produto',
            no_products: 'Nenhum produto encontrado com os critérios selecionados.',
            no_image: 'Sem Imagem',
            price: 'Preço',
            sku: 'SKU',
            success_category: 'Categoria criada com sucesso!',
            success_product: 'Produto criado com sucesso!',
            success_update: 'Produto atualizado com sucesso!',
            success_delete: 'Produto excluído com sucesso!',
            success_delete_cat: 'Categoria excluída com sucesso!',
            error_fetch: 'Erro ao buscar produtos',
            error_category: 'Erro ao criar categoria',
            error_product: 'Erro ao criar produto',
            error_update: 'Erro ao atualizar produto',
            error_delete: 'Erro ao excluir produto',
            error_delete_cat: 'Erro ao excluir categoria',
          },
          cart: {
            title: 'Gerenciamento de Carrinho',
            select_client: 'Selecionar Cliente',
            search_client: 'Buscar e Selecionar Cliente',
            add_item_title: 'Adicionar Item ao Carrinho',
            select_product: 'Selecionar Produto',
            cart_for: 'Carrinho de',
            clear_cart: 'Limpar Carrinho',
            clearing: 'Limpando...',
            empty: 'O carrinho está vazio.',
            item_added: 'Item adicionado ao carrinho.',
            item_removed: 'Item removido do carrinho.',
            cart_cleared: 'Carrinho limpo com sucesso.',
            error_add: 'Falha ao adicionar item ao carrinho.',
            error_remove: 'Falha ao remover item.',
            error_clear: 'Falha ao limpar carrinho.',
            required: 'Por favor, selecione um cliente, produto e uma quantidade válida.',
          },
            profile: {
            title: 'Perfil',
            person_name: 'Nome da Pessoa',
            tenant_name: 'Nome da Empresa / Inquilino',
            login_email: 'E-mail de Login',
            edit_profile: 'Editar Perfil',
            change_password: 'Alterar Senha',
            delete_account: 'Excluir Conta',
            deleting: 'Excluindo...',
            confirm_delete_title: 'Confirmar Exclusão da Conta',
            confirm_delete_body: 'Tem certeza absoluta que deseja excluir sua conta? Todos os dados associados serão perdidos permanentemente. Esta ação não pode ser desfeita.',
            confirm_delete: 'Confirmar Exclusão',
            success_update: 'Perfil atualizado com sucesso!',
            error_update: 'Falha ao atualizar perfil.',
            all_required: 'Todos os campos são obrigatórios.',
            custom_question: 'Pergunta Personalizada ao Cliente',
            custom_question_helper: 'Pergunta feita aos clientes durante o cadastro (ex: "Cor Favorita"). Deixe em branco para desativar.',
          },
          purchases: {
            title: 'Compras (Sessões de Pagamento)',
            session_id: 'ID da Sessão',
            total_amount: 'Valor Total',
            payment_method: 'Método de Pagamento',
            confirmed_at: 'Confirmado em',
            details: 'Detalhes',
            no_sessions: 'Nenhuma sessão de pagamento encontrada para este cliente.',
            payment_link: 'Link de Pagamento',
            current_step: 'Etapa Atual',
            external_id: 'ID de Pagamento Externo',
            preference_id: 'ID de Preferência',
          }
        }
      }
    }
  });

export default i18n;
